export default [
  {
    path: '',
    component: () => import('@/layouts/main.vue'),
    children: [
      {
        path: '/jianpai-scm/error-log/list',
        name: 'AppUpdateConfig',
        component: () => import('@/views/jianpai-scm/error-log/list.vue'),
        meta: {
          title: '简派SCM异常列表',
          noCache: false,
          auth: true,
        },
      },
    ],
  },
];
